import Gallery from "./Gallery";
import Video from "./Vidios";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";

export default function GalleryPage(params) {
    const { t } = useTranslation();

    return<>
           
            <Gallery/>
            <Video/>
    </>
}